import AxiosService from '../../../gateway/rest/AxiosService'

class MssqlDatabaseRestService {
  static async getPrimaryDatabase() {
    return AxiosService.get('/adaptermssql/databases/getPrimaryDatabase')
  }

  static async configurePrimaryDatabase(primaryDatabase: any) {
    return AxiosService.put('/adaptermssql/databases/putPrimaryDatabase', null, {
      params: {
        ...primaryDatabase,
      },
    })
  }
}

export default MssqlDatabaseRestService
